<template>
  <v-dialog
    :value="value"
    fullscreen
    hide-overlay
    transition="slide-x-transition"
    @input="$emit('input', $event)"
  >
    <v-card class="msp-libreria-allenamenti">
      <v-toolbar flat dark>
        <v-btn icon @click="goBack">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title>{{ titolo }}</v-toolbar-title>
      </v-toolbar>

      <v-card-text class="libreria-content pa-0">

        <div v-if="loading" class="text-center pa-4">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>

        <v-list v-else-if="step === 'categorie'">
          <v-list-item
            v-for="cat in categorie"
            :key="cat.id"
            @click="selectCategoria(cat)"
          >
            <v-list-item-avatar>
              <v-icon>mdi-folder</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ cat.descrizione }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action class="categoria-count">
              ({{ cat.count }})
            </v-list-item-action>
            <v-list-item-action>
              <v-icon>mdi-chevron-right</v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-list-item v-if="!categorie.length">
            <v-list-item-content>
              <v-list-item-title class="grey--text">Nessuna categoria trovata</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <div v-else-if="step === 'allenamenti'" class="libreria-allenamenti-list">
          <div
            v-for="al in allenamenti"
            :key="al.id"
            @click="selectAllenamento(al)"
          >
          <v-list-item>
            <v-list-item-avatar>
              <span class="item-icon">
                <i :class="'item-icon-sport msp-icon-sport-' + al.sport_id"></i>
              </span>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ al.titolo }}</v-list-item-title>
              <v-list-item-subtitle v-if="al.totalone" class="item-totali">
                <span v-html="formatoRisultato(al.totalone.sec, 'sec', al.sport_id)"></span>
                <span v-html="formatoRisultato(al.totalone.mt, 'km', al.sport_id)"></span>
                <span v-if="al.trimp">{{ Math.round(al.trimp) }} <small>trimp</small></span>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon class="item-info" @click.stop="openInfo(al)">
                <v-icon color="grey lighten-1">mdi-information</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <div v-if="hasGraficoAndature(al)" class="item-grafico">
            <msp-grafico-andature-semplice
              v-bind="al.totalone.grafico"
              :colore="true"
            />
          </div>
<v-divider></v-divider>
          </div>
          <div v-if="!allenamenti.length" class="grey--text pa-4">Nessun allenamento in questa categoria</div>
        </div>

        <div v-else-if="step === 'data'" class="pa-4">
          <v-date-picker
            v-model="data"
            full-width
            locale="it-it"
            :first-day-of-week="1"
            no-title
          ></v-date-picker>
          <v-btn
            block
            color="primary"
            class="mt-2"
            :loading="saving"
            @click="aggiungi"
          >
            Aggiungi
          </v-btn>
        </div>

      </v-card-text>

      <v-dialog v-model="showInfo" max-width="400" scrollable>
        <v-card v-if="infoAllenamento" class="libreria-info-dialog">
          <v-toolbar flat dense dark>
        <v-toolbar-title>Anteprima</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="showInfo = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pa-0">
            <msp-allenamento-preview :show-icon="true" :allenamento="infoAllenamento" />
          </v-card-text>
          <v-card-actions>
            <v-btn block color="primary" @click="insertFromInfo">Aggiungi a calendario</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-card>
  </v-dialog>
</template>

<script>
import _api from "@mixins/api.js";
import _funzioni from "@src/js/msp/funzioni.js";
import _cal from "@src/js/vue/mixins/calendario.js";
import _constants from "@src/js/msp/constants.js";
import MspGraficoAndatureSemplice from '@src/mobile/src/components/MspGraficoAndatureSemplice.vue';
import MspAllenamentoPreview from '@src/mobile/src/components/MspAllenamentoPreview.vue';

const api_base_url = process.env.VUE_APP_API_BASE_URL;

export default {
  name: "MspLibreriaAllenamenti",
  components: {
    MspGraficoAndatureSemplice,
    MspAllenamentoPreview,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    atletaId: {
      type: Number,
      default: null,
    },
  },

  data: () => ({
    step: "categorie",
    loading: false,
    saving: false,
    categorie: [],
    allenamenti: [],
    categoriaSelezionata: null,
    allenamentoSelezionato: null,
    data: _cal.date2ymd(),
    showInfo: false,
    infoAllenamento: null,
  }),

  computed: {
    titolo() {
      if (this.step === "allenamenti" && this.categoriaSelezionata) {
        return `${this.categoriaSelezionata.descrizione} (${this.allenamenti.length})`;
      }
      if (this.step === "data" && this.allenamentoSelezionato) {
        return this.allenamentoSelezionato.titolo;
      }
      return "Libreria allenamenti";
    },
  },

  watch: {
    value(val) {
      if (val && !this.categorie.length) {
        this.loadCategorie();
      }
      if (!val) {
        this.reset();
      }
    },
  },

  methods: {
    hasGraficoAndature: _funzioni.hasGraficoAndature,
    openInfo(al) {
      this.infoAllenamento = al;
      this.showInfo = true;
    },
    insertFromInfo() {
      this.showInfo = false;
      this.selectAllenamento(this.infoAllenamento);
    },
    formatoRisultato(val, um, sport_id) {
      if (!val) return "";
      if (um === 'sec') return _funzioni.sec2hms(val);
      if (sport_id == _constants.sport_id.nuoto) return Math.round(val) + " <small>mt</small>";
      if (sport_id == _constants.sport_id.podismo) return (val / 1000).toFixed(1) + " <small>km</small>";
      return "";
    },

    goBack() {
      if (this.step === "allenamenti") {
        this.step = "categorie";
      } else if (this.step === "data") {
        this.step = "allenamenti";
      } else {
        this.$emit("input", false);
      }
    },

    reset() {
      this.step = "categorie";
      this.allenamenti = [];
      this.categoriaSelezionata = null;
      this.allenamentoSelezionato = null;
    },

    async loadCategorie() {
      this.loading = true;
      const url = api_base_url + "/api/v2/categoria.php?tipo=allenamento";
      const result = await _api(url, "GET");
      this.loading = false;
      if (result && result.success) {
        this.categorie = result.data || [];
      }
    },

    async selectCategoria(cat) {
      this.categoriaSelezionata = cat;
      this.loading = true;
      this.step = "allenamenti";
      const url = api_base_url + "/api/v2/allenamento_libreria.php?categoria_id=" + cat.id;
      const result = await _api(url, "GET");
      this.loading = false;
      if (result && result.success) {
        this.allenamenti = result.data.result || [];
      }
    },

    selectAllenamento(al) {
      this.allenamentoSelezionato = al;
      this.step = "data";
    },

    async aggiungi() {
      if (!this.allenamentoSelezionato) return;
      this.saving = true;
      const result = await this.$store.dispatch("calendario/addAllenamentoDaLibreria", {
        allenamento_id: this.allenamentoSelezionato.id,
        data: this.data,
      });
      this.saving = false;
      if (result) {
        this.$emit("added", result);
        this.$emit("input", false);
      }
    },
  },
};
</script>
<style>
.msp-libreria-allenamenti {
    .libreria-content {
        overflow-y: auto;
        height: calc(100vh - 56px);
    }
    .categoria-count {
        font-size: 13px;
        color: var(--col-grigio, #888);
        min-width: 0;
    }
    .libreria-allenamento-item {
        position: relative;
        display: block;
        border-bottom: 2px solid var(--col-grigio-chiaro, #ddd);
        margin-bottom: 2px;
        cursor: pointer;

        &:active {
            background: var(--col-msp-chiaro, #f0f0f0);
        }
        .v-list-item {
            padding: 4px 8px;
        }
    }
    .item-icon {
        font-size: 28px;
    }
    .item-totali {
        display: flex;
        gap: 8px;
        align-items: center;
    }
    .item-grafico {
        height: 50px;
        padding: 10px;
    }
}
.libreria-info-dialog {
    .grafico-andature {
        height: 60px;
    }
    .info-totalone {
        display: flex;
        gap: 12px;
        font-size: 13px;
        color: var(--col-grigio, #666);
    }
    .info-note {
        font-size: 0.9em;
        white-space: pre-wrap;
        color: rgba(0,0,0,0.7);
    }
}
</style>
